import { Meta } from "@angular/platform-browser";
import { Component, OnInit } from "@angular/core";
import { GalleryService } from "src/app/services/gallery.service";
import { catchError, map, throwError } from "rxjs";
import { SeoServiceService } from "src/app/services/seo-service.service";

interface MyObject {
  id: number;
  name: string;
  img: string;
}

@Component({
  selector: "app-pm-shri",
  templateUrl: "./pm-shri.component.html",
  styleUrls: ["./pm-shri.component.scss"],
})
export class PmShriComponent implements OnInit {
  imageArray1: MyObject[] | any;
  imageArray2: MyObject[] | any;
  imageArray3: MyObject[] | any;
  data: any;

  constructor(
    private meta: Meta,
    private gallery: GalleryService,
    private seoService: SeoServiceService
  ) {}

  getgallery() {
    this.gallery
      .getPMgallery()
      .pipe(
        map((res: any) => {
          this.data = res.details;
          this.loadArray();
        }),
        catchError((error) => {
          return throwError(error.massage || error);
        })
      )
      .subscribe();
  }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.getgallery();
    this.meta.addTag({
      name: "Description",
      content:
        "PM Shri Schools Activity: Initiative by the Prime Minister promoting educational activities for students, fostering learning and growth.",
    });
  }

  loadArray() {
    const chunkSize = Math.ceil(this.data.length / 3); // Calculate chunk size
    // Slice the data array into three parts
    this.imageArray1 = this.data.slice(0, chunkSize);
    this.imageArray2 = this.data.slice(chunkSize, chunkSize * 2);
    this.imageArray3 = this.data.slice(chunkSize * 2);
  }
}
